module.exports = __webpack_public_path__ + "static/media/19ESCAP28.d826380a.jpg";